function DDUMainMenu({value}) {
    return (
        <div className="flex items-center justify-center bg-[#137fec33] w-full h-full">
            <p className="material-symbols-outlined text-[25px] text-[#838383]">apps</p>
        </div>
    );
}

export default DDUMainMenu;